export const BASKET_TYPES = {
    SEATS: 'seats',
    PRICE: 'price',
    PAYMENT: 'payment',
    RESERVATION: 'reservation',
}

export const RELATIVE_BASKET_TYPES = [BASKET_TYPES.PRICE, BASKET_TYPES.PAYMENT, BASKET_TYPES.RESERVATION]

export const ALLOWED_PAYMENTS = {
    CASH: 'Cash',
    GP_WEBPAY: 'GPWebpay',
    GOPAY: 'Gopay',
    BENEFITY: 'Benefity',
    BENEFITY_PLUS: 'BenefityPlus',
    CAFETERIA: 'Cafeteria',
    EDEN_RED: 'EdenRed',
    GALLERY_BETA: 'GalleryBeta',
    MOBILE_PAYMENT: 'MobilePayment',
    GOOGLE_PAY: 'GooglePay',
    APPLE_PAY: 'ApplePay',
    CLICK_TO_PAY: 'ClickToPay',
}
